import type { Editor } from '@tiptap/react';
import { useEffect } from 'react';
import { useCanvasImageUploadHandler } from 'components/editor/hooks/useCanvasImageUploadHandler';
import type { InlineImageStorage } from '../extensions/inline-image';
import { INLINE_IMAGE_NODE_NAME } from '../extensions/inline-image';

// Hands the document-scoped image upload to the editor's inline image extension, so pasted image files
// are uploaded to the document library before being inserted.
export const useInlineImageInsertion = (editor: Editor | null, isEnabled: boolean) => {
  const { handleImageUpload } = useCanvasImageUploadHandler();

  useEffect(() => {
    const storage = editor?.storage[INLINE_IMAGE_NODE_NAME] as InlineImageStorage | undefined;
    if (!editor || editor.isDestroyed || !storage) return;

    storage.isInsertEnabled = isEnabled;
    storage.uploadImageFiles = handleImageUpload;
  }, [editor, isEnabled, handleImageUpload]);
};
